<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <fieldset>
    <legend>
      {{ $t('Add your business details') }}
    </legend>

    <BusinessEntityInput
      v-model="soleTraderUtr"
      :disabled="disabled"
      :label="$t('UTR')"
      name="business_entity_data[sole_trader_utr]"
      required
    />
    <BusinessEntityInput
      v-model="registeredCompanyName"
      :disabled="disabled"
      :label="$t('Business name')"
      name="registered_company_name"
    />

    <BusinessEntityVat
      v-model:business-entity="internalBusinessEntity"
      :compliance-data="complianceData"
      :disabled="disabled"
    />
  </fieldset>
</template>

<script>
/* eslint-disable import/extensions */
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import BusinessEntityVat from '@/components/compliances/BusinessEntity/BusinessEntityVat.vue'
import { deepClone, setdefault } from '@/utils/tools'

export default {
  components: {
    BusinessEntityInput,
    BusinessEntityVat,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    complianceData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    freelancer: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)
    return {
      internalBusinessEntity,
    }
  },
  computed: {
    companyNo: {
      get() {
        return this.internalBusinessEntity.companyNo
      },
      set(companyNo) {
        this.internalBusinessEntity.companyNo = companyNo
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    registeredCompanyName: {
      get() {
        return this.internalBusinessEntity.companyName
      },
      set(registeredCompanyName) {
        this.internalBusinessEntity.companyName = registeredCompanyName
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    soleTraderUtr: {
      get() {
        return this.internalBusinessEntity.data?.sole_trader_utr
      },
      set(soleTraderUtr) {
        const data = setdefault(this.internalBusinessEntity, 'data', {})
        data.sole_trader_utr = soleTraderUtr
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
